import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";

export class EmailInput extends LanguageInput
{
  email:string;
}

export class UserSignUpRequest extends PHPRequest<PHPAdress,EmailInput,PHPResponse>
{
  static readonly ADRESS = PHPAdresses.USER_SIGN_UP;

  constructor(){ super( UserSignUpRequest.ADRESS ); }

}
